import React from 'react';
import LoaderIcon from './LoaderIcon';

const Loader = () => {
  return (
    <section>
      <div className='bg-black opacity-30 dark:opacity-40 top-0 left-0 fixed w-full h-full'></div>
      <div
        role='status'
        className='absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2 flex items-center flex-col  w-1/2 p-6 rounded-lg  '
      >
        <LoaderIcon />
      </div>
    </section>
  );
};

export default Loader;
